// extracted by mini-css-extract-plugin
export default {"badge":"MicrositeRedirectTypeBadge_badge__s08TH","tone_301":"MicrositeRedirectTypeBadge_tone_301__8FcdU","tone_302":"MicrositeRedirectTypeBadge_tone_302__03N+j"};